import React from 'react';
import './App.css';
import SignIn from './components/Account/SignIn/SignIn.js';
import EnhancedSignIn from './components/Account/SignIn/EnhancedSignIn.js';
import SignUp from './components/Account/SignUp/SignUp.js';
import EnhancedSignUp from './components/Account/SignUp/EnhancedSignUp.js';
import UpdateAccount from './components/Account/Update Account ';
import NewTicket from './components/Tickets/NewTicket'
import TicketTable from './components/Tickets/TicketTable';
import EnhancedTicketTable from './components/Tickets/EnhancedTicketTable';
import PublicCases from './components/Tickets/PublicCases';
import PublicCaseDetail from './components/Tickets/PublicCaseDetail';
import HeaderDemo from './components/HeaderDemo';
import ResetPassword from './components/Account/ResetPassword';
import EnhancedResetPassword from './components/Account/EnhancedResetPassword';
import EnhancedNewPassword from './components/Account/EnhancedNewPassword';
import {  Routes ,Route} from 'react-router-dom';
import ProtectedRoute from './components/ProtectedRoute';

function App()  {
  return (
          <>
            <Routes onUpdate={() => window.scrollTo(0, 0)}>
              <Route path="/" element={<ProtectedRoute component={<EnhancedTicketTable/>}/>}/>
                {/* My Added Code */}   
                <Route path="/sign-up" element={<EnhancedSignUp update={false} />}/>
                <Route path="/enhanced-sign-up" element={<EnhancedSignUp update={false} />}/>
                <Route path="/my-account" element={<EnhancedSignUp update={true} />}/>
                <Route path="/reset-password" element={<EnhancedResetPassword/>}/>
                <Route path="/enhanced-reset-password" element={<EnhancedResetPassword/>}/>
                <Route path="/new-password/:token" element={<EnhancedNewPassword/>}/>
                <Route path="/new-ticket" element={<ProtectedRoute component={<NewTicket/>}/>}/>
                <Route path="/enhanced-tickets" element={<ProtectedRoute component={<EnhancedTicketTable/>}/>}/>
                <Route path="/public-cases" element={<ProtectedRoute component={<PublicCases/>}/>}/>
                <Route path="/public-case/:caseId" element={<ProtectedRoute component={<PublicCaseDetail/>}/>}/>
                <Route path="/public-case/:caseId/:email" element={<ProtectedRoute component={<PublicCaseDetail/>}/>}/>
                <Route path="/header-demo" element={<ProtectedRoute component={<HeaderDemo/>}/>}/>
                {/* <Route path="/tickets" element={<TicketTable/>}/> */}
                <Route path="/activate/:id" element={<EnhancedSignIn/>}/>
                <Route path="/sign-in" element={<EnhancedSignIn/>}/>
                <Route path="/enhanced-sign-in" element={<EnhancedSignIn/>}/>
                <Route path="*" element={<h1>404</h1>}/>
            </Routes>
            <hr/>
            {/* <footer>
              <div>© <a href="https://rowad-rme.com">Rowad Modern Engineering</a> </div>
              <div>All rights reserved. {new Date().getFullYear() }</div>
            </footer> */}
          </>
 
  );
};
export default App;